import { AdobeAnalyticsService } from './AdobeAnalyticsService';

const getUserLocationStatus = () => (getCookie('USERINSEECODE') !== '' && getCookie('USERZIPCODE') !== '' ? '1' : '0');

const getUserId = () => getCookie('s_vi');

const getPostalCode = () => getCookie('USERZIPCODE');

const getUserEmail = () => getCookie('PCKEMAIL');

const getCookie = (cname: string) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

const getAdobeCloudExperienceId = () => {
  const cookie = getCookie(AdobeAnalyticsService.ADOBE_CLOUD_EXPERIENCE_ID);
  if (!cookie) return;

  const decodedId = decodeURIComponent(cookie);
  const parts = decodedId.split('|');

  if (parts.length > 2) {
    return parts[2];
  }
};

const saveAdobeCloudExperienceId = (adobeCloudExperienceId: string) => {
  const timestamp = Math.floor(Date.now() / 1000);
  const fields = [
    '1176715910',
    'MCMID',
    adobeCloudExperienceId,
    `MCAAMLH-${timestamp}`,
    '6',
    `MCAAMB-${timestamp}`,
    '6G1ynYcLPuiQxYZrsz_pkqfLG9yMXBpb2zX5dvJdYQJzPXImdj0y',
    `MCOPTOUT-${timestamp}s`,
    'NONE',
    'vVersion',
    '5.4.0',
  ];
  document.cookie = 'AMCV_' + AdobeAnalyticsService.ORGANIZATION_ID + '=' + encodeURIComponent(fields.join('|'));
};

export const CookiesHandler = {
  getUserLocationStatus,
  getUserEmail,
  getUserId,
  getPostalCode,
  getAdobeCloudExperienceId,
  saveAdobeCloudExperienceId,
};
